<script setup>

const { locale } = useI18n()

const newsletterUI = await useUIFetch(locale.value, 'form/newsletter')

const emailField = newsletterUI.body.find(item => item.type === 'Email')
const checkboxField = newsletterUI.body.find(item => item.type === 'Checkbox')
const submitField = newsletterUI.body.find(item => item.type === 'SubmitButton')

const getInTouchForm = ref(null)
const isSubmitting = ref(false)
const privacyPolicy = ref(false)
const privacyError = ref(false)

const success = ref(null)

const props = defineProps({
  cover: {
    type: Boolean,
		default: false
  },
	width: {
		type: Number,
		default: 0
	},
	page: {
    type: Boolean,
		default: false
  },
	withoutTitle: {
		type: Boolean,
		default: false
	}
})

const gdpr = () => {
  privacyPolicy.value = !privacyPolicy.value

	if (privacyError.value) privacyError.value = false
}

const submitHandler = async (value) => {

	if(privacyPolicy.value) {

		isSubmitting.value = true

		const formData = new FormData()
		formData.append('email', value.email)
		formData.append('agreeterms', true)
		formData.append('_submit', newsletterUI.body.find(item => item.name === '_submit').value)
		formData.append('_do', 'NewsletterForm-submit')

		const response = await useFormPost(locale.value, 'form/newsletter', {
			method: 'post',
			body: formData,
		})

		if(response.success) {
			success.value = response.success_message
		}

	} else {
		privacyError.value = true
	}
}

</script>

<template>
	<div class="col-span-2 xl:col-span-1 cover">
		<div :class="[page ? 'p-4 xl:p-10 dark:bg-dark8 bg-lightBg8': '']">
			<div v-if="!withoutTitle">
				<h3 v-if="cover || page" class="text-dark dark:text-light" :class="[cover ? `text-[${Math.round(width/12)}px] mb-[${Math.round(width/20)}px]` : 'mb-6']">Newsletter</h3>
				<h1 v-else class="text-red mb-6">Newsletter</h1>
			</div>
			<p v-if="!withoutTitle" class="dark:text-light" :class="[cover ? `${width < 280 ? `text-[${Math.round(width/16)}px] mb-[${Math.round(width/20)}px]` : 'text-lg mb-4'}` : 'text-lg mb-8']">{{ $t('newsletter.subtitle') }}</p>
			<div :class="{'mb-28' : !cover && !page}">
				<FormKit
					v-if="!success"
					ref="getInTouchForm"
					type="form"
					:actions="false"
					@submit="submitHandler"
				>
					<div class="md:flex w-full">
						<div class="w-full mb-5" :class="{'mb-3' : !cover}">
							<FormKit
								:classes="{
									input: `${cover ? `cover ${width < 280 ? `text-[${Math.round(width/16)}px] py-[${Math.round(width/28)}px] px-[${Math.round(width/28)}px]` : ' text-xl py-2.5 px-4'}` : ''}`,
								}"
								type="email"
								name="email"
								id="email"
								:placeholder="emailField?.placeholder"
								validation="required|email"
								:validation-messages="{
									required: emailField?.validator.filled,
									email: emailField?.validator.valid,
								}"
							/>
						</div>
						<div class="md:ml-3 mb-5 md:mb-0" v-show="!cover">
							<FormKit
								type="submit"
								:classes="{
									input: `${page ? 'green' : ''}`,
								}"
							>
								<span>{{submitField?.label}}</span>
							</FormKit>
						</div>
					</div>
					<Checkbox
						name="gdpr"
						@toggle="gdpr"
						:show-error="privacyError"
						:class="{'mb-8' : cover}"
					>
						<span v-html="$t('newsletter.agreement')" />
					</Checkbox>
					<div v-show="cover">
						<FormKit
							type="submit"
							:classes="{
								input: 'cover p-[20px]',
							}"
						>
							<span>{{ submitField?.label }}</span>
						</FormKit>
					</div>
				</FormKit>
				<h5 v-else class="text-green">{{ success }}</h5>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.cover {
	container-type: inline-size;
}
</style>